module.exports = __webpack_public_path__ + "static/media/no-knowledge-point.628c6f2e.png";